<template>
  <div class="web-ad">
    <div class="header-tool">
      <div class="header-tool-info">
        <Breadcrumb>
          <BreadcrumbItem>首页</BreadcrumbItem>
          <BreadcrumbItem>网站设置</BreadcrumbItem>
          <BreadcrumbItem>广告管理</BreadcrumbItem>
        </Breadcrumb>
        <div class="header-tool-title">广告管理</div>
      </div>
      <div class="header-tool-box">
        <div class="htb-item" @click="showAudience=true;">
          <span>添加广告</span>
        </div>
      </div>
    </div>
    <!-- <div class="header-switch">
      <div class="header-switch-text">网站广告的设置</div>
    </div> -->

    <div class="header-tabs">
      <Tabs :animated="false" @on-click="switchBrand" v-model="showTabs">
        <TabPane label="中文顶部banner" name="1">
          <adAudience ref="adAudience" />
        </TabPane>
        <TabPane label="英文顶部banner" name="2">
          <adAudienceEn ref="adAudienceEn" />
        </TabPane>
      </Tabs>
    </div>

    <webAudienceAdAdd
      :show="showAudience" 
      @finish="finish"
      @close="showAudience=false;"
      :type="showTabs"
    />
  </div>
</template>

<script>
import adAudience from "../components/web-ad-audience.vue";
import adAudienceEn from "../components/web-ad-audienceEn.vue";
import webAudienceAdAdd from "../components/web-audiencead-add.vue";

export default {
  name: "host-webSet-ad",
  data() {
    return {
      showTabs: "1",
      show: false,
      showAudience: false,
    };
  },
  methods: {
    switchBrand(name) {
      if (name === "1") {
        this.$router.push(`${this.$route.path}?type=home`);
      } else if (name === "2") {
        this.$router.push(`${this.$route.path}?type=supply`);
      } else if (name === "3") {
        this.$router.push(`${this.$route.path}?type=top`);
      } else if (name === "4") {
        this.$router.push(`${this.$route.path}?type=audience`);
      }
    },
    finish() {
      if (this.showTabs === "1") {
        this.$refs['adAudience'].init();
      }
      if (this.showTabs === "2") {
        this.$refs['adAudienceEn'].init();
      }
    }
  },
  created() {
    let query = this.$route.query;
    if (query && query.type && query.type === "home") {
      this.showTabs = "1";
    }
    if (query && query.type && query.type === "supply") {
      this.showTabs = "2";
    }
    if (query && query.type && query.type === "top") {
      this.showTabs = "3";
    }
    if (query && query.type && query.type === "audience") {
      this.showTabs = "4";
    }
  },
  components: {
    adAudience,
    adAudienceEn,
    webAudienceAdAdd
  }
};
</script>

<style lang="scss" scoped>
.web-ad {
  .header-switch {
    display: flex;
    align-items: center;
    padding: 0 35px 18px 35px;
    background: #fff;
    &-text {
      flex: 1;
      font-size: 14px;
      color: #808080;
    }
    &-box {
      flex: 1;
      text-align: right;
    }
  }
}
</style>